import { Directive, OnInit, ElementRef, HostListener, Input } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { NgControl } from '@angular/forms';
import { take } from 'rxjs/operators';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[thousands-separator]'
})
export class ThousandsSeparatorDirective implements OnInit {
  // build the regex based on max pre decimal digits allowed
  private regexString(max?: number) {
    const maxStr = max ? `{0,${max}}` : `+`;
    return `^(\\d${maxStr}(\\.\\d{0,2})?|\\.\\d{0,2})$`;
  }
  private digitRegex: RegExp;
  private setRegex(maxDigits?: number) {
    this.digitRegex = new RegExp(this.regexString(maxDigits), 'g');
  }
  @Input()
  set maxDigits(maxDigits: number) {
    this.setRegex(maxDigits);
  }

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private currencyPipe: CurrencyPipe,
    private control: NgControl
  ) {
    this.el = this.elementRef.nativeElement;
    this.setRegex();
  }

  ngOnInit() {
    const abstractControl = this.control.control;
    if (!!abstractControl) {
      abstractControl.valueChanges.pipe(take(1)).subscribe((x) => {
        this.el.value = this.formatOnBlur(this.el.value, x);
      });
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value: string) {
    this.el.value = this.formatOnFocus(value);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    this.el.value = this.formatOnBlur(this.el.value, value);
  }

  /**
   * on focus, remove currency formatting
   * @param value
   * @returns
   */
  private formatOnFocus(value: string): string {
    if (!value) return '';
    let arrNumber = value.split(',');

    if (arrNumber.length > 1) {
      let decimal = Number(arrNumber[1]) > 0 ? `.${arrNumber[1]}` : ``;
      value = `${arrNumber[0].replace(/\./g, '')}${decimal}`;
    } else {
      value = `${arrNumber[0].replace(/\./g, '')}`;
    }

    return value;
  }

  /**
   * on blur, add currency formatting
   * @param value
   * @param incognitValue
   * @returns
   */
  private formatOnBlur(value: string, incognitValue: string): string {
    if (!value) return '';
    value = this.currencyPipe.transform(incognitValue, '', '');
    let arrNumber = value.split('.');

    if (arrNumber.length > 1) {
      value = `${arrNumber[0].replace(/,/g, '.')},${arrNumber[1]}`;
    } else {
      value = `${arrNumber[0].replace(/,/g, '.')}`;
    }

    return value;
  }

  // variable to store last valid input
  private lastValid = '';
  @HostListener('input', ['$event'])
  onInput(event: any) {
    // on input, run regex to only allow certain characters and format
    const cleanValue = (event.target.value.match(this.digitRegex) || []).join('');
    if (cleanValue || !event.target.value) this.lastValid = cleanValue;
    this.el.value = cleanValue || this.lastValid;
  }
}
